'use strict';

module.exports = {
    reward: 'reward',
    requirement: 'requirement',
};
